// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ModalTerms_modalOverlay__YbHXt","modalContent":"ModalTerms_modalContent__rrUeb","closeButton":"ModalTerms_closeButton__HKJSj"};